import '../styles/globals.css';
import App from 'next/app';
import type { AppProps } from 'next/app';
import Head from 'next/head';
import { GlobalStyles } from 'condolivre-ds';
import { DateTime, Settings } from 'luxon';
import cookie from 'cookie';
import UserContext from '../components/User/User';
import Cookies from 'universal-cookie';
import { AuthProvider } from '../providers/Auth';
import themeStyle from '../styles/theme';
import React, { useEffect, useState } from 'react';
import TagManager from 'react-gtm-module';
import { useRouter } from 'next/router';
import { PartnerProvider } from '../providers/Partner';
import { usePartner } from '../providers/Partner';
import { HelmetProvider } from 'src/providers/Helmet';
import GoogleTagManager from '../components/GoogleTagManager/GoogleTagManager';
import { getGtmId } from 'src/helpers';

Settings.defaultLocale = 'pt-BR';
DateTime.now().locale;

interface Props {
	gtmId: string;
	authenticated?: boolean;
	user?: any;
	appContext?: any;
	ctx: any;
	Component: any;
	AppTree: any;
	router: any;
}

function MyApp({
	Component,
	pageProps,
	authenticated,
	user,
	gtmId,
}: AppProps & Props) {
	const router = useRouter();

	useEffect(() => {
		import('react-facebook-pixel')
			.then(x => x.default)
			.then(ReactPixel => {
				ReactPixel.init('931493264703026');
				ReactPixel.pageView();

				router.events.on('routeChangeComplete', () => {
					ReactPixel.pageView();
				});
			});
	}, [router.events]);

	useEffect(() => {
		TagManager.initialize({ gtmId: 'GTM-NH52358' });
	}, []);

	const [refresh, setRefresh] = useState(false);

	useEffect(() => {
		setTimeout(function () {
			setRefresh(true);
		}, 100);
	}, []);

	const { name } = usePartner();

	return (
		<>
			{gtmId && <GoogleTagManager tagId={gtmId} />}
			{refresh && (
				<PartnerProvider>
					<HelmetProvider />
					<GlobalStyles theme={themeStyle}>
						<AuthProvider authenticated={authenticated}>
							<UserContext.Provider value={user}>
								<Component {...pageProps} />
							</UserContext.Provider>
						</AuthProvider>
					</GlobalStyles>
				</PartnerProvider>
			)}
		</>
	);
}

MyApp.getInitialProps = async (appContext: Props) => {
	let authenticated = false;
	const cookies = new Cookies();
	const newUser = cookies.get('user');
	let user = JSON.stringify(newUser);

	const request = appContext.ctx.req;

	if (request) {
		request.cookies = cookie.parse(request.headers.cookie || '');
		authenticated = !!request.cookies.session;

		user = request.cookies.user;
	}

	if (!user) {
		return {
			redirect: {
				destination: '/login',
				permanent: false,
			},
		};
	}

	const GTM_ID = getGtmId();
	const appProps = await App.getInitialProps(appContext);
	return { ...appProps, authenticated, user, gtmId: GTM_ID };
};

export default MyApp;
